import { useEffect, useRef, useState } from "react";

function MenuDotsIcon() {
  return (
    <svg viewBox="0 0 24 24">
      <circle cx="5" cy="12" r="1.8" />
      <circle cx="12" cy="12" r="1.8" />
      <circle cx="19" cy="12" r="1.8" />
    </svg>
  );
}

export default function TeamActionMenu({
  open,
  disabled,
  onToggle,
  onClose,
  onEdit,
  onAssignCampaign,
  onToggleStatus,
  member,
}) {
  const rootRef = useRef(null);
  const buttonRef = useRef(null);
  const [menuPosition, setMenuPosition] = useState(null);

  const isActive = member?.status?.toLowerCase() === 'active';
  const toggleButtonText = isActive ? 'Deactivate' : 'Activate';
  const toggleButtonVariant = isActive ? 'danger' : 'success';

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleClickOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onClose, open]);

  useEffect(() => {
    if (!open) {
      setMenuPosition(null);
      return undefined;
    }

    const updatePosition = () => {
      if (!buttonRef.current) {
        return;
      }

      const rect = buttonRef.current.getBoundingClientRect();
      const menuWidth = 164;
      const padding = 12;
      const left = Math.max(
        padding,
        Math.min(rect.right - menuWidth, window.innerWidth - menuWidth - padding),
      );

      setMenuPosition({
        top: rect.bottom + 8,
        left,
      });
    };

    updatePosition();
    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);

    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
  }, [open]);

  return (
    <div ref={rootRef} className={`team-action-menu ${open ? "open" : ""}`.trim()}>
      <button
        ref={buttonRef}
        type="button"
        className="team-action-menu-trigger"
        aria-label="Open team member actions"
        aria-expanded={open}
        aria-haspopup="menu"
        disabled={disabled}
        onClick={() => {
          if (open) {
            onClose();
            return;
          }

          onToggle();
        }}
      >
        <MenuDotsIcon />
      </button>

      {open ? (
        <div
          className="team-action-menu-dropdown"
          style={menuPosition || undefined}
          role="menu"
        >
          <button type="button" className="team-action-menu-item" onClick={onEdit}>
            Edit
          </button>
          <button
            type="button"
            className="team-action-menu-item"
            onClick={onAssignCampaign}
          >
            Assign Campaign
          </button>
          <button
            type="button"
            className={`team-action-menu-item ${toggleButtonVariant}`}
            onClick={onToggleStatus}
          >
            {toggleButtonText}
          </button>
        </div>
      ) : null}
    </div>
  );
}